import GaClient from './ga-client';

export default GaClient;
